import React, { FC, useCallback, useMemo } from 'react';

import { getPlaygroundDetailList } from '../../../api/playgroundApi';
import PageList from '../../../components/PageList';
import PGCard, { type Props as PGCardProps } from '../../../components/PGCard';

import styles from './PlaygroundProgressList.module.scss';
import { BreakPoint, useScreenSize } from '../../../components/ScreenSize';

const PlayGroundItem: any = (item: PGCardProps['pgCardData']) => {
  return (
    <div className={styles['playground-item']}>
      <PGCard pgCardData={item} />
    </div>
  );
};

const PlayGroundProgressList: FC<{ lanType: string; prePageText?: string; nextPageText?: string }> = (props) => {
  const { lanType, prePageText, nextPageText } = props;
  const renderItem = PlayGroundItem;
  const onLoadData = useCallback(
    async (page: { pageSize: number; pageNo: number; status?: string }) => {
      const { pageSize, pageNo, status } = page;
      const {
        data: { pageContent, page: resPage },
      } = await getPlaygroundDetailList({ pageSize, pageNo, lanType, status: status as any });
      return {
        data: pageContent,
        page: {
          pageSize,
          pageNo,
          totalCount: resPage?.totalCount,
        },
      };
    },
    [lanType],
  );

  const { screen } = useScreenSize();

  const pageSize = useMemo(() => {
    return screen === BreakPoint.sm ? 8 : 9;
  }, [screen]);

  return (
    <div className={styles['playground-progress-list']}>
      <PageList
        key={pageSize}
        defaultPageSize={pageSize}
        prePageText={prePageText}
        nextPageText={nextPageText}
        renderItem={renderItem}
        onLoadData={onLoadData}
      />
    </div>
  );
};

export default PlayGroundProgressList;
